const createSegmentModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/fragments/create-segment-modal/create-segment-modal.html',
  controller: 'CreateSegmentModalController',
};

angular
  .module('pis-tool.module')
  .component('createSegmentModal', createSegmentModal);
